
<mat-card *ngIf="loaded && courses | async as courses; else loading">
  <mat-card-header>
    <mat-card-title>Courses</mat-card-title>
    <a mat-button [routerLink]="['/courses/create']" color="primary">Add Course</a>
  </mat-card-header>

  <mat-card-content>
    <mat-accordion>
      <ng-template ngFor let-course [ngForOf]="courses">
        <!--Course Start -->
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header>
            <div class="d-flex col-12 align-items-center">
              <mat-panel-title>{{course.title}}</mat-panel-title>
              <mat-slide-toggle
                [checked]="!!course.activated"
                [disabled]="!course.country || !course.subject"
                (change)="toggleActive(course)"
                (click)="$event.stopPropagation()"
                class="mr-4"
              >ON</mat-slide-toggle>
              <button mat-button color="primary" [routerLink]="['/courses/' + course.id + '/manage']">
                Manage
              </button>
              <button mat-button color="primary" [routerLink]="['/courses/' + course.id + '/edit']">Edit</button>
            </div>
          </mat-expansion-panel-header>

          <!--<p>Subject: {{course.subject}}</p>-->
          <p>{{course.description}}</p>
          <mat-card>
            <mat-card-title>
              Lessons
              <button mat-button color="primary" [routerLink]="['/courses/' + course.id + '/lessons/create']">
                Add Lesson
              </button>
            </mat-card-title>
            <mat-card-content>
            <mat-accordion>
              <!--Lesson Start -->
              <mat-expansion-panel *ngFor="let lesson of course.lessons" [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>{{lesson.title}}</mat-panel-title>
                  <button mat-button color="primary"
                          [routerLink]="['/courses/' + course.id + '/lessons/' + lesson.id + '/manage']">
                    Manage
                  </button>
                  <button mat-button color="primary" [routerLink]="['/courses/' + course.id + '/lessons/' + lesson.id + '/edit']">
                    Edit
                  </button>
                </mat-expansion-panel-header>

                <p>{{lesson.description}}</p>

                <!-- Exercises Start-->
                <mat-card>
                  <mat-card-title>
                    Exercises
                    <button mat-button color="primary" [routerLink]="['/courses/' +course.id +'/lessons/' + lesson.id +'/exercises/create']">
                      Add Exercise
                    </button>
                  </mat-card-title>
                  <mat-card-content>
                    <mat-accordion>
                      <mat-expansion-panel [expanded]="true">
                        <mat-list>
                          <mat-list-item *ngFor="let exercise of lesson.exercises">
                            <mat-panel-title>{{exercise.title}}</mat-panel-title>
                            <button mat-button color="primary"
                                    [routerLink]="['/courses/' + course.id + '/lessons/' + lesson.id + '/exercises/' + exercise.id + '/manage']">
                              Manage
                            </button>
                          </mat-list-item>
                        </mat-list>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </mat-card-content>
                </mat-card>
                <!--Exercises End-->

              </mat-expansion-panel>
            </mat-accordion>
            </mat-card-content>
            <!--Lesson End -->
          </mat-card>
        </mat-expansion-panel>
        <!--Course End-->
      </ng-template>
    </mat-accordion>
  </mat-card-content>
</mat-card>
<ng-template #loading>
  <app-spinner></app-spinner>
</ng-template>
